import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interface
import { ICreate } from "Interfaces/ICreate";
import { IOrder } from "Interfaces/IOrder";
import { Inputs, IData } from "Interfaces/IServiceOrder";
//utils
import { CurrencyFormat } from "utils/CurrencyFormat";
import FormatarData from "utils/FormatData";

export default function UpdateOS({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastData,
  setToastOpen,
  selectedUrlId
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const {
    isLoading: isLoadingSubmit,
    startLoading: startLoadingSubmit,
    stopLoading: stopLoadingSubmit
  } = useLoading();
  const [dataSale, setDataSale] = useState<IData | null>(null);

  const listHeadTable = [
    "Tipo",
    "Produto",
    "Qtd.",
    "Preço",
    "Desconto",
    "Subtotal",
  ];

  const fieldsOD = [
    { name: "spherical_right", label: "ESFÉRICO" },
    { name: "cylindrical_right", label: "CILÍNDRICO" },
    { name: "axis_right", label: "EIXO" },
    { name: "dnp_right", label: "DNP" },
    { name: "addition_right", label: "ADIÇÃO" },
    { name: "height_right", label: "ALTURA" },
  ] as const;

  const fieldsOE = [
    { name: "spherical_left", label: "ESFÉRICO" },
    { name: "cylindrical_left", label: "CILÍNDRICO" },
    { name: "axis_left", label: "EIXO" },
    { name: "dnp_left", label: "DNP" },
    { name: "addition_left", label: "ADIÇÃO" },
    { name: "height_left", label: "ALTURA" },
  ] as const;

  const fieldsBridge = [
    { name: "bridge", label: "PONTE" },
    { name: "larger_horizontal", label: "HORIZONTAL MAIOR" },
    { name: "larger_vertical", label: "VERTICAL MAIOR" },
    { name: "larger_diagonal", label: "DIAGONAL MAIOR" },
  ] as const;

  const fieldsDnpAlt = [
    { name: "dnp_v_right", label: "DNP V - OD" },
    { name: "dnp_v_left", label: "DNP V - OE" },
    { name: "alt_right", label: "ALT V - OD" },
    { name: "alt_left", label: "ALT V - OE" },
  ] as const;

  const fieldsPonte = [
    "bridge",
    "larger_horizontal",
    "larger_vertical",
    "larger_diagonal"
  ] as const;

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(
        `service-order/${selectedUrlId}`
      );
      const responseData = response.data;
      const responseDataInput = response.data.serviceOrder;

      setDataSale(responseData);
      console.log('setDataSale: ', response.data);
      for (const key in responseDataInput) {
        setValue(key as keyof Inputs, responseDataInput[key]);
      }

    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoadingSubmit();
    try {
      const payload = {
        ...data,
        sale_id: dataSale ? dataSale?.saleInfo?.id : null,
      }

      const response = await apiRequest(`service-order/${selectedUrlId}`, 'PATCH', payload);
      if (response.status === 200) {
        setToastData({
          status: response.status,
          message: 'Atualizado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();
      }
    } catch (error: any) {
      console.log('error: ', error);
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoadingSubmit();
    }
  };

  const onClose = () => {
    setDataSale(null);
    setModalClose();
    reset();
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoadingSubmit}
        title="Registrar Ordem de Serviço"
        subTitle="Cadastre uma nova os em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar OS'}
      >

        {isLoading ? (
          <Loading />
        ) : (

          <S.Container>
            {dataSale &&
              <S.ContentInfor>
                <S.Subtitle>Data da Venda: {FormatarData(dataSale.saleInfo.date_sale, 'default-data')}</S.Subtitle>
                <S.Subtitle>Vendedor: {dataSale.saleInfo?.seller?.name || '-'}</S.Subtitle>
                <S.Subtitle>Numero da Venda: {dataSale.saleInfo?.number_ata || '-'}</S.Subtitle>
                {
                  dataSale.lenses.map((lab) =>
                    <S.ContentInfor>
                      <S.Subtitle>Laboratório: {lab.laboratory || 'Não informado'}</S.Subtitle>
                      <S.Subtitle>Prazo de Entrega: {lab.delivery > 1 ? `${lab.delivery} dias` : `${lab.delivery} dia`}</S.Subtitle>
                    </S.ContentInfor>
                  )
                }
              </S.ContentInfor>
            }

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Ordem de Serviço
                  <span>*</span>
                </S.Label>
                <S.Input
                  isStyle={true}
                  placeholder="Informe a ordem de serviço"
                  type="string"
                  {...register("number_os", { required: true })}
                  as='input'
                />
                {errors.number_os && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Data de Entrega
                  <span>*</span>
                </S.Label>
                <S.Input
                  isStyle={true}
                  as='input'
                  type="date"
                  {...register("delivery", { required: true })} />
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>Observação</S.Label>
              <S.TextArea
                placeholder="Campo Opcional -  dicione observações relevantes sobre a OS"
                rows={2}
                {...register("observation")}
              />
            </S.FormInput>

            <S.Section>
              <S.HeaderSection>
                <S.Text className="title">
                  Informações do Grau e Montagem
                </S.Text>
              </S.HeaderSection>

              <S.BodySection>
                <S.Text className="title">
                  Olho Direito - OD
                </S.Text>

                <S.ContentGrid>
                  {
                    fieldsOD.map((fieldName, index) => (
                      <S.FormInput className="form-center" key={index}>
                        <S.Label>
                          {fieldName.label || '-'}
                          <span>*</span>
                        </S.Label>
                        <S.Input
                          isStyle={false}
                          as='input'
                          placeholder="0"
                          type="text"
                          {...register(fieldName.name)}
                        />
                      </S.FormInput>
                    ))
                  }
                </S.ContentGrid>
              </S.BodySection>

              <S.BodySection>
                <S.Text className="title">
                  Olho Esquerdo - OE
                </S.Text>

                <S.ContentGrid>
                  {
                    fieldsOE.map((fieldName, index) => (
                      <S.FormInput className="form-center" key={index}>
                        <S.Label>
                          {fieldName.label || '-'}
                          <span>*</span>
                        </S.Label>
                        <S.Input
                          isStyle={false}
                          as='input'
                          placeholder="0"
                          type="text"
                          {...register(fieldName.name)}
                        />
                      </S.FormInput>
                    ))
                  }
                </S.ContentGrid>
              </S.BodySection>
            </S.Section>

            <S.Section>
              <S.HeaderSection>
                <S.Text className="title">
                  Medidas Vision Office
                </S.Text>
              </S.HeaderSection>

              <S.BodySection>
                <S.Text className="title">
                  Medidas da Ponte
                </S.Text>

                <S.ContentGrid>
                  {
                    fieldsBridge.map((fieldName, index) => (
                      <S.FormInput className="form-center" key={index}>
                        <S.Label>
                          {fieldName.label || '-'}
                          <span>*</span>
                        </S.Label>
                        <S.Input
                          isStyle={false}
                          as='input'
                          placeholder="0"
                          type="text"
                          {...register(fieldName.name)}
                        />
                      </S.FormInput>
                    ))
                  }
                </S.ContentGrid>
              </S.BodySection>

              <S.BodySection>
                <S.Text className="title">
                  DNP V e ALT V por Olho
                </S.Text>

                <S.ContentGrid>
                  {
                    fieldsDnpAlt.map((fieldName, index) => (
                      <S.FormInput className="form-center" key={index}>
                        <S.Label>
                          {fieldName.label || '-'}
                          <span>*</span>
                        </S.Label>
                        <S.Input
                          isStyle={false}
                          as='input'
                          placeholder="0"
                          type="text"
                          {...register(fieldName.name)}
                        />
                      </S.FormInput>
                    ))
                  }
                </S.ContentGrid>
              </S.BodySection>
            </S.Section>

            <S.Text>
              <span>Legenda: </span>OD: OLHO DIREITO -
              OE: OLHO ESQUERDO -
              DNP: DISTÂNCIA NASO-PUPILAR |
              ALT: ALTURA |
              ADI: ADIÇÃO |
              DNP V: DISTÂNCIA NASO-PUPILAR VISION |
              ALT V: ALTURA VISION
            </S.Text>

            {/* table */}
            {dataSale &&
              <>
                <S.ContainerTable>
                  <S.TableWrapper>

                    <S.Table>
                      <S.Thead>
                        <S.Tr>
                          {listHeadTable.map((header) => {
                            return <th>{header}</th>;
                          })}
                        </S.Tr>
                      </S.Thead>

                      <S.Tbody>
                        {
                          dataSale.items.length > 0 &&
                          dataSale.items.map((val, index) =>
                            <S.Tr>
                              <S.Td key={index}>
                                {val.product?.type || '-'}
                              </S.Td>
                              <S.Td key={index}>
                                {val.product?.name || '-'}
                              </S.Td>
                              <S.Td key={index}>
                                {val.quantity || '-'}
                              </S.Td>
                              <S.Td key={index}>
                                {val.unit_price || '0'}
                              </S.Td>
                              <S.Td key={index}>
                                {val.promotion?.discount_value || '-'}
                              </S.Td>
                              <S.Td key={index}>
                                {val.total || '0'}
                              </S.Td>
                            </S.Tr>
                          )
                        }
                      </S.Tbody>
                    </S.Table>
                  </S.TableWrapper>
                </S.ContainerTable>

                {/* Informações do Cliente */}
                <S.ContentInfor>
                  <S.Infor>
                    <S.Subtitle>Cliente</S.Subtitle>
                    <S.InforDescription>
                      {dataSale.saleInfo?.customer?.name || '-'}
                    </S.InforDescription>
                  </S.Infor>

                  <S.Infor>
                    <S.Subtitle>Convênio</S.Subtitle>
                    <S.InforDescription>
                      {dataSale.saleInfo?.customer?.agreement || 'Não informado'}
                    </S.InforDescription>
                  </S.Infor>

                  <S.Infor>
                    <S.Subtitle>CPF</S.Subtitle>
                    <S.InforDescription>
                      {dataSale.saleInfo?.customer?.cpf || '-'}
                    </S.InforDescription>
                  </S.Infor>
                </S.ContentInfor>

                <S.ContentInfor>
                  <S.Subtitle>Total da Compra</S.Subtitle>
                  <S.InforTitle>
                    {dataSale.saleInfo.total_amount || '0'}
                  </S.InforTitle>
                </S.ContentInfor>
              </>
            }

          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
